import { off, onChildAdded, onChildChanged, onValue, query, ref } from "firebase/database";
import { useEffect, useState } from "react";
import { database } from "src/authentication/firebase";


const AdminText = ({className} :any) => {

    const [adminText, setAdminText] = useState("");

    useEffect(()=>{
  const chatRef = ref(database, "admin/adminstring");

  const unsubscribe = onValue(chatRef, (snapshot) => {
    const newMessage = snapshot.val();
    setAdminText(newMessage?.text || "");
  });

  return () => {
    off(chatRef); // clean up listener
  };
    }, []);
    




    return <div className={`${className} ${adminText ? "":"invisible"}`}> {adminText ? adminText : "a"}
    </div>
}

export default AdminText;